import { Icon } from '@chakra-ui/react';
import { Button } from '@diamond/shared/ui';
import { ReceiptLongOutlined as ReceiptLongIcon } from '@mui/icons-material';
import Link from 'next/link';
import { memo } from 'react';

import { InvoiceButtonProps } from './types';

const InvoiceButton = memo(({ link }: InvoiceButtonProps) => (
  <Link href={link} target="_blank" rel="noopener noreferrer">
    <Button
      type="button"
      variant="solid"
      size={{ base: 'xs', md: 'md' }}
      py="1.0625rem"
      color="white"
    >
      <Icon as={ReceiptLongIcon} />
    </Button>
  </Link>
));

InvoiceButton.displayName = 'InvoiceButton';

export { InvoiceButton };
